import { useTranslate } from "ra-core";
import { useMemo } from "react";

import type { TemplateTexts } from "./excelWorkbook";
import type { SheetColumnKind } from "./types";

const KINDS: SheetColumnKind[] = [
  "text",
  "long_text",
  "number",
  "currency",
  "date",
  "datetime",
  "choice",
  "choices",
  "rating",
  "boolean",
  "phone",
];

/** Texts of the Excel import template, in the user's language. */
export const useTemplateTexts = (): TemplateTexts => {
  const translate = useTranslate();
  return useMemo(() => {
    const text = (key: string, options?: object) =>
      translate(`crm.spreadsheet.template.${key}`, options);
    return {
      instructionsSheet: text("instructions_sheet"),
      listsSheet: text("lists_sheet"),
      title: text("title"),
      steps: [text("step_1"), text("step_2"), text("step_3"), text("step_4")],
      tableHeaders: [
        text("table.column"),
        text("table.required"),
        text("table.values"),
        text("table.example"),
      ],
      required: text("required"),
      optional: text("optional"),
      kinds: Object.fromEntries(
        KINDS.map((kind) => [kind, text(`kinds.${kind}`)]),
      ) as TemplateTexts["kinds"],
      listPrompt: text("list_prompt"),
      choicesPrompt: text("choices_prompt"),
      ratingError: text("rating_error"),
      listError: text("list_error"),
      numberError: text("number_error"),
      dateError: text("date_error"),
    };
  }, [translate]);
};
